import { BaseApiModel } from './BaseApiModel';

export class Type extends BaseApiModel {
  public code: string;
  public description: string;
  public regionId: string;
  public createdAt: string;
  public modifiedAt: string;
  public deletedAt: string;
}
